import React, { useState } from 'react';
import {
  TooltipDefinition,
  TooltipDefinitionProps
} from 'carbon-components-react';
import { debounce } from 'lodash';

const CustomTooltipDefinition: React.FC<TooltipDefinitionProps> = ({
  children,
  className,
  ...rest
}) => {
  const [showToolTips, setShowToolTips] = useState<boolean>(false);
  const handleMouseEnter = debounce(() => setShowToolTips(true), 500);
  const handleMouseLeave = () => {
    handleMouseEnter.cancel();
    setShowToolTips(false);
  };

  return (
    <TooltipDefinition
      {...rest}
      className={`${className} custom--tooltip--definition${
        showToolTips ? ' show-tooltips' : ''
      }`}
      onMouseEnter={() => handleMouseEnter()}
      onMouseLeave={() => handleMouseLeave()}
    >
      {children}
    </TooltipDefinition>
  );
};

export default CustomTooltipDefinition;
